import { CommonModule, formatDate } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { ClaimRow } from '../../../models/Claim';
import { DetailPair } from '../../../../../shared/components/detail-info-card/DetailPair';
import { DetailInfoCardComponent } from '../../../../../shared/components/detail-info-card/detail-info-card.component';

@Component({
  selector: 'app-delete-undelete-claim-dialog',
  templateUrl: './delete-undelete-claim-dialog.component.html',
  styleUrls: ['./delete-undelete-claim-dialog.component.scss'],
  standalone: true,
  imports: [
    CommonModule, 
    DetailInfoCardComponent,
    MatDialogModule,
    MatButtonModule
  ]
})
export class DeleteUndeleteClaimDialogComponent implements OnInit {

  deleteClaim: boolean = true;
  claim: any;
  claimRow!: ClaimRow;
  claimDetails: DetailPair[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<DeleteUndeleteClaimDialogComponent>
  ) { }

  ngOnInit() {
    this.claim = this.data.claim;
    this.claimRow = this.data.claimRow;
    this.deleteClaim = this.data.deleteClaim;
    
    if (!this.deleteClaim) {
      this.populateClaimDetails()
    }
  }

  populateClaimDetails() {
    if (this.claimRow) {
      this.claimDetails.push(new DetailPair("Claim ID", `${this.claim.id}`));
      this.claimDetails.push(new DetailPair("Reservation ID", this.claim.reservation_id));
      this.claimDetails.push(new DetailPair("Organization", this.claim.organization.name));
      this.claimDetails.push(new DetailPair("Property Name", this.claimRow.propertyName));
      this.claimDetails.push(new DetailPair("Guest Name", this.claimRow.firstName + ' ' + this.claimRow.lastName));
      this.claimDetails.push(new DetailPair("Status", this.claimRow.pillStatus));
      this.claimDetails.push(new DetailPair("Arrival Date", formatDate(this.claim.reservation.arrival_date, 'shortDate', 'en-US', 'UTC')));
      this.claimDetails.push(new DetailPair("Departure Date", formatDate(this.claim.reservation.departure_date, 'shortDate', 'en-US', 'UTC')));
    } else {
      this.claimDetails.push(new DetailPair("Claim ID", `${this.claim.id}`));
      this.claimDetails.push(new DetailPair("Reservation ID", this.claim.reservation_id));
      this.claimDetails.push(new DetailPair("Organization", this.claim.organization.name));
      this.claimDetails.push(new DetailPair("Property Name", this.claim.property.name));
      this.claimDetails.push(new DetailPair("Guest Name", this.claim.send_check_to_name));
      this.claimDetails.push(new DetailPair("Arrival Date", formatDate(this.claim.reservation.arrival_date, 'shortDate', 'en-US', 'UTC')));
      this.claimDetails.push(new DetailPair("Departure Date", formatDate(this.claim.reservation.departure_date, 'shortDate', 'en-US', 'UTC')));
    }
  }

  onDeleteClick() {
    this.dialogRef.close(0);
  }

  onUndeleteClick() {
    this.dialogRef.close(1);
  }

  onCancelClick() {
    this.dialogRef.close(null);
  }
}